import React from 'react';
import styled from "styled-components";
import Logo from "../header/Logo";
import Facebook from "../svg/Facebook";
import Instagram from "../svg/Instagram";
import WhatsApp from "../svg/WhatsApp";



const Footer = () => {
    return (
        <FooterStyled>
        
        <Logo
            clase={"width20"}
        />
        <div>
        <Facebook
            clase="width5"
        />
        <Instagram
        clase="width6"
        />
        <WhatsApp
        clase="width6"
        />
        </div>
        <p>Servicios</p>
        <p>Contacto</p>
        <p>blog</p>
        <p>© 2021 IMPLUSA | Desarrollo web por IMPULSA</p>
        </FooterStyled>

      );
}
 
export default Footer;


const FooterStyled = styled.footer`

padding: 20px;
background-color: #7433EF;
margin-top: 150px;

div{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 40px 0;
    }

p{
    cursor: pointer;
    text-align: center;
    color: #FFF;
    text-transform: uppercase;
    letter-spacing: 0.3em;
    :hover{
        text-decoration:underline;
    }


    
}
`